
// src/components/common/ExportButton.jsx
import React, { useState, useRef, useEffect } from 'react';
import { ArrowDownTrayIcon, ChevronDownIcon } from '@heroicons/react/24/outline';

const ExportButton = ({ onExportCSV, onExportXLS, label = 'Esporta', size = 'sm' }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const sizes = {
        sm: 'px-3 py-1.5 text-xs',
        md: 'px-4 py-2 text-sm',
    };

    return (
        <div className="relative" ref={ref}>
            <button
                onClick={() => setOpen(!open)}
                className={`flex items-center gap-1.5 ${sizes[size]} bg-white border border-gray-200 text-gray-700 rounded-xl hover:bg-gray-50 hover:border-gray-300 transition font-medium`}
            >
                <ArrowDownTrayIcon className="w-3.5 h-3.5" />
                {label}
                <ChevronDownIcon className={`w-3 h-3 transition-transform ${open ? 'rotate-180' : ''}`} />
            </button>

            {open && (
                <div className="absolute right-0 top-full mt-1.5 w-44 bg-white border border-gray-100 rounded-xl shadow-lg z-20 overflow-hidden">
                    <div className="p-1">
                        <button
                            onClick={() => { onExportCSV(); setOpen(false); }}
                            className="w-full flex items-center gap-2.5 px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition text-left"
                        >
                            <span className="text-base">📄</span>
                            <div>
                                <p className="font-medium">CSV</p>
                                <p className="text-xs text-gray-400">Compatibile con tutti</p>
                            </div>
                        </button>
                        <button
                            onClick={() => { onExportXLS(); setOpen(false); }}
                            className="w-full flex items-center gap-2.5 px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition text-left"
                        >
                            <span className="text-base">📊</span>
                            <div>
                                <p className="font-medium">Excel (.xls)</p>
                                <p className="text-xs text-gray-400">Apri con Excel</p>
                            </div>
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ExportButton;